import {
  ChartBar,
  ClockCounterClockwise,
  Cpu,
  GearSix,
  SlidersHorizontal,
  UserCircle,
  Users,
} from '@phosphor-icons/react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';

const SECTIONS = [
  {
    key: '/app/settings/workspace',
    label: 'Workspace',
    icon: <GearSix size={16} />,
  },
  {
    key: '/app/settings/account',
    label: 'Account',
    icon: <UserCircle size={16} />,
  },
  { key: '/app/settings/members', label: 'Members', icon: <Users size={16} /> },
  {
    key: '/app/settings/platforms',
    label: 'Platform settings',
    icon: <SlidersHorizontal size={16} />,
  },
  {
    key: '/app/settings/usage',
    label: 'Usage & Telemetry',
    icon: <ChartBar size={16} />,
  },
  {
    key: '/app/settings/activity',
    label: 'Activity log',
    icon: <ClockCounterClockwise size={16} />,
  },
  {
    key: '/app/settings/jobs',
    label: 'Background jobs',
    icon: <Cpu size={16} />,
  },
];

export function SettingsLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const selected = SECTIONS.map((section) => section.key)
    .filter(
      (key) =>
        location.pathname === key || location.pathname.startsWith(`${key}/`)
    )
    .sort((a, b) => b.length - a.length)[0];

  return (
    <div className="flex min-h-[calc(100vh-56px)] flex-col items-stretch md:flex-row md:items-start">
      <aside className="w-full shrink-0 overflow-x-auto border-b border-border bg-card/30 p-3.5 md:sticky md:top-14 md:h-[calc(100vh-56px)] md:w-60 md:overflow-x-visible md:overflow-y-auto md:border-r md:border-b-0 md:px-4 md:py-6">
        <h2 className="text-xs font-bold uppercase tracking-wider text-muted-foreground mb-3 px-2">
          Settings
        </h2>
        <nav className="flex gap-1 overflow-x-auto pb-1 md:flex-col md:overflow-x-visible md:pb-0">
          {SECTIONS.map((section) => {
            const isActive = selected === section.key;
            return (
              <button
                key={section.key}
                type="button"
                onClick={() => navigate(section.key)}
                className={cn(
                  'group flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm font-medium transition-all whitespace-nowrap cursor-pointer text-left',
                  isActive
                    ? 'bg-primary/10 text-primary font-bold shadow-xs'
                    : 'text-foreground hover:bg-muted/60 hover:text-primary'
                )}
              >
                <span
                  className={cn(
                    isActive
                      ? 'text-primary'
                      : 'text-foreground group-hover:text-primary'
                  )}
                >
                  {section.icon}
                </span>
                <span>{section.label}</span>
              </button>
            );
          })}
        </nav>
      </aside>

      <div className="w-full min-w-0 max-w-5xl flex-1 px-4 py-5 sm:px-6 sm:py-6 lg:px-10">
        <Outlet />
      </div>
    </div>
  );
}
